export default __webpack_public_path__ + "static/media/twitter.7145a483.svg";